import { Inject, Injectable } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { HttpModel } from "../models/http.model";
import { throwError } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from "angular-l10n";

@Injectable()
export class HttpResponseHandlerService {

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale, public translationService: L10nTranslationService, private toastr: ToastrService) {
  }

  public handlePostResponse(postResponse: HttpModel, showToast: boolean = true): boolean {
    if (postResponse.result) {
      if (showToast) {
        if (postResponse.message) {
          this.toastr.success(this.translationService.translate(postResponse.message), this.translationService.translate("GENERAL.SUCCESS"), {
            timeOut: 2000,
            extendedTimeOut: 3000
          });
        } else {
          this.toastr.success("", this.translationService.translate("GENERAL.SUCCESS"), {
            timeOut: 2000,
            extendedTimeOut: 3000
          });
        }
      }
    } else {
      if (postResponse.message) {
        this.toastr.error(this.translationService.translate(postResponse.message), this.translationService.translate("GENERAL.ERROR"), {
          closeButton: true
        });
      } else {
        if (showToast) {
          this.toastr.error("", this.translationService.translate("GENERAL.ERROR"), {
            closeButton: true
          });
        }
      }
    }

    return postResponse.result;
  }

  public handleGetResponse(getResponse: any, showToast: boolean = true): any {
    if (!getResponse.result && showToast) {
      if (getResponse.message) {
        this.toastr.error(this.translationService.translate(getResponse.message), this.translationService.translate("GENERAL.ERROR"), {
          closeButton: true
        });
      } else {
        this.toastr.error("", this.translationService.translate("GENERAL.ERROR"), {
          closeButton: true
        });
      }
    } else if (showToast && getResponse.message !== "") {
      if (getResponse.message) {
        this.toastr.success(this.translationService.translate(getResponse.message), this.translationService.translate("GENERAL.SUCCESS"), {
          timeOut: 2000,
          extendedTimeOut: 3000
        });
      } else {
        this.toastr.success("", this.translationService.translate("GENERAL.SUCCESS"), {
          timeOut: 2000,
          extendedTimeOut: 3000
        });
      }
    }
    return getResponse.result;
  }

  public handleError(error: HttpErrorResponse, showToast: boolean = false) {
    let errMsg: string;
    console.log(error);
    if (error.status === 404) {
      errMsg = this.translationService.translate("ERROR.404");
      showToast = true;
    } else if (error.error instanceof ErrorEvent) {
      // localize here
      errMsg = error.error.message || "";
      if (errMsg !== "") {
        errMsg = this.translationService.translate(errMsg);
      }
    } else if (error.error) {
      errMsg = this.translationService.translate(error.error);
    }
    if (showToast) {
      this.toastr.error(errMsg, this.translationService.translate("GENERAL.ERROR"), {
        closeButton: true
      });
    }
    return throwError(errMsg);
  }

}
